const scroller = document.querySelectorAll('.scroller');
const scrolling_containers = document.querySelectorAll('.section_posts_wrapper');

scroller.forEach( element => {
  element.addEventListener('click', event => {
    const button = event.target.closest('.scroller');
    const scrolling_container = event.target.closest('.section_posts_wrapper');
    const post_container = event.target.closest('.section_posts');
    const last_post = post_container.children[post_container.children.length-1];
    const post_width = post_container.children[0].clientWidth;
    let scroll_distance = post_width*2.2;

    // console.log(button);

    if( button.classList.contains('right') ) {
      scrolling_container.scrollLeft += scroll_distance;
    } else {
      scrolling_container.scrollLeft -= scroll_distance;
    }

    if( scrolling_container.classList.contains('at_end') ) {
      swup.loadPage({
        url: event.target.getAttribute('href'),
        method: 'GET',
        data: data
      });
    }
    event.stopImmediatePropagation();
    event.preventDefault();
  });
});

scrolling_containers.forEach( element => {
  element.addEventListener('scroll', event => {
    const first_element = event.target.querySelector('div:first-child');
    const last_element = event.target.querySelector('article:last-of-type');

    if( first_element.getBoundingClientRect().left < 0 ) {
      element.classList.remove('at_start');
    } else {
      element.classList.add('at_start');
    }

    if( last_element.getBoundingClientRect().right < window.innerWidth ) {
      element.classList.add('at_end');
    } else {
      element.classList.remove('at_end');
    }
    // console.log(first_element.getBoundingClientRect());
    // console.log(last_element.getBoundingClientRect());
    // console.log(window.innerWidth);
  });
});
